import React, { useEffect, useState } from 'react';
import { Avatar, AvatarProps } from '@mui/material';
import apiCall from '../../utils/api';

interface SecureAvatarProps extends AvatarProps {
  src?: string;
}

const SecureAvatar: React.FC<SecureAvatarProps> = ({ src, ...props }) => {
  const [imageSrc, setImageSrc] = useState<string | undefined>(undefined);

  useEffect(() => {
    let active = true;
    let objectUrl: string | null = null;

    const fetchImage = async () => {
      if (!src) {
        setImageSrc(undefined);
        return;
      }

      if (src.startsWith('http') || src.startsWith('blob:') || src.startsWith('data:')) {
        setImageSrc(src);
        return;
      }

      try {
        const response = await apiCall<Blob>(
          'get',
          `/api/fetch-s3-file/?file_path=${encodeURIComponent(src)}&file_format=blob`,
          undefined,
          undefined,
          'blob'
        );

        if (active && response.data instanceof Blob) {
          objectUrl = URL.createObjectURL(response.data);
          setImageSrc(objectUrl);
        }
      } catch (error) {
        console.error("Failed to fetch secure avatar:", error);
      }
    };

    fetchImage();

    return () => {
      active = false;
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [src]);

  return <Avatar {...props} src={imageSrc} />;
};

export default SecureAvatar;
